<template>
  <pt-poster-detail class="pt-poster-detail__withData" v-loading="loading" :poster="currentPoster"></pt-poster-detail>
</template>

<script>
import PtPosterDetail from './index'
export default {
  name: 'pt-poster-detail__withData',
  components: {
    'pt-poster-detail': PtPosterDetail
  },
  data () {
    return {
      loading: false,
      currentPoster: {}
    }
  },
  methods: {
    //  获取商品详情
    getGoodsDetail (id) {
      this.loading = true
      this.$store.dispatch('getCommodityDetailPoster', id).then(res => {
        this.loading = false
        this.$set(this.currentPoster, 'goodsData', res)
      }).catch(err => {
        this.loading = true
        this.$message.error(err || '获取商品详情失败', 'error')
      })
    },
    load () {
      this.loading = true
      this.$store.dispatch('getPosterDetail', this.$route.params.id).then(data => {
        this.loading = false
        this.currentPoster = data
        data.goodsId && this.getGoodsDetail(data.goodsId)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
